export const trackNotification = ({
  action,
  headline,
}: {
  action: 'close';
  headline: string;
}) => {
  const event = {
    event: 'notification',
    action: action,
    label: headline,
    value: null,
  };

  return event;
};
